import { useOrderContext } from "app/providers/OrderProvider";
import StatusGif from "entities/status-gif";
import Confetti from "shared/ui/confetti";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";
import { isDevelopmentEnvironment } from "shared/utils/checkEnvironment";
import { getLocalDateString } from "shared/utils/date";
import { twMerge } from "tailwind-merge";
import OrderLoader from "widgets/shared/order-loader";
import StatusSupport from "widgets/status-support";

const AppointmentCreated = () => {
  const { order, isOrderFetching } = useOrderContext();

  return (
    <>
      <Confetti />

      {isOrderFetching ? (
        <OrderLoader />
      ) : (
        <div
          className={twMerge(
            isDevelopmentEnvironment() ? "gg-mx-auto" : "",
            "gg-max-w-3xl"
          )}
        >
          <Confetti />

          <div className="gg-mb-14">
            <StatusGif
              src={`https://media1.giphy.com/media/ua4OxpbgAtItnS5hWu/giphy.gif`}
              alt="Een GewoonGers Gif. Een monteur springt uit zijn bus."
            />

            <Heading headingLevel="h1" className="gg-mb-3 md:gg-mb-5">
              Gers komt naar je toe!
            </Heading>

            <Text className="gg-text-xl md:gg-text-2xl gg-mb-3 md:gg-mb-5">
              Hallo {order?.shippingAddress.firstName}{" "}
              {order?.shippingAddress.lastName}
            </Text>

            {order?.measurementDate && order.shippingAddress ? (
              <Text className="gg-text-lg">
                Leuk dat we welkom zijn op{" "}
                <span className="gg-font-bold">
                  {order.shippingAddress.street}{" "}
                  {order.shippingAddress.houseNumber},{" "}
                  {order.shippingAddress.zip} in {order.shippingAddress.city}
                </span>
                . Op{" "}
                <span className="gg-font-bold">
                  {getLocalDateString(new Date(order?.measurementDate))}
                </span>{" "}
                komen we langs voor gratis inmeten en advies. Zet je 'm in de
                agenda?
              </Text>
            ) : (
              <></>
            )}
          </div>

          <StatusSupport />
        </div>
      )}
    </>
  );
};
export default AppointmentCreated;
